module.exports = __webpack_public_path__ + "img/example-photo.14bff7ce.webp";